import { env } from "configs/EnvironmentConfig";
import { TYPE_LINKS_MAP } from "constants/IssueInvoiceConstant";
import fetch from "../auth/FetchInterceptor";

const SummaryInvoiceDataService = {};

SummaryInvoiceDataService.listInvoiceCycles = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/invoice-cycles`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
    },
  });
};

// releaseInvoiceCycles
SummaryInvoiceDataService.releaseInvoiceCycles = id => {
  return fetch({
    url: `${env.API_MSP}/invoice-cycles/release/${id}`,
    method: "post",
  });
};

// searchKHDD
SummaryInvoiceDataService.searchKHDD = id => {
  return fetch({
    url: `${env.API_MSP}/invoice-cycles/ky-hieu/${id}`,
    method: "get",
    params: {
      type: 1,
    },
  });
};

// searchInvoice
// {{api_endpoint}}/invoice-cycles/ky-hieu/5?quarter=1&year=2021&type=1
// {{api_endpoint}}/invoice-cycles/ky-hieu/5?month=11&year=2021&type=2&kyhieu=KH001
SummaryInvoiceDataService.searchInvoice = (params, khmshdon) => {
  return fetch({
    url: `${env.API_MSP}/invoice-cycles/ky-hieu/${khmshdon}`,
    method: "get",
    params: {
      //   kyhieu: "K22TCC",
      //   month: 11,
      //   type: 2,
      //   year: 2021,
      ...params,
    },
  });
};

SummaryInvoiceDataService.createInvoiceCycles = data => {
  return fetch({
    url: `${env.API_MSP}/invoice-cycles`,
    method: "post",
    data,
  });
};

SummaryInvoiceDataService.createReportInvoiceError = (data, buTenantHeader) => {
  return fetch({
    url: `${env.API_MSP}/reports`,
    method: "post",
    data: {
      ...data,
      bu_code: buTenantHeader,
    },
  });
};

SummaryInvoiceDataService.createReportInvoice = (data, typeReport) => {
  return fetch({
    url: `${env.API_MSP}/reports`,
    method: "post",
    data: {
      ...data,
      type: typeReport,
    },
  });
};

SummaryInvoiceDataService.progressReportInvoice = id => {
  return fetch({
    url: `${env.API_MSP}/reports/progress/${id}`,
    method: "get",
  });
};

// transfer
SummaryInvoiceDataService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

//
SummaryInvoiceDataService.downloadReport = (resource_id, responseType) => {
  return fetch({
    url: `${env.API_MSP}/reports/download/${resource_id}`,
    method: "get",
    responseType,
  });
};

//
SummaryInvoiceDataService.executeReport = id => {
  return fetch({
    url: `${env.API_MSP}/reports/execute/${id}`,
    method: "post",
  });
};

SummaryInvoiceDataService.listReportInvoice = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/reports`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
    },
  });
};

SummaryInvoiceDataService.listInvoiceReplace = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/links`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[type][in]": [
        TYPE_LINKS_MAP.TYPE_REPLACE,
        TYPE_LINKS_MAP.TYPE_REPLACE_TT32,
      ],
    },
  });
};

SummaryInvoiceDataService.listInvoiceAdjust = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/links`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[type][in]": [
        TYPE_LINKS_MAP.TYPE_ADJUST_DECREMENT,
        TYPE_LINKS_MAP.TYPE_ADJUST_INCREMENT,
        TYPE_LINKS_MAP.TYPE_ADJUST_INFO,
        TYPE_LINKS_MAP.TYPE_ADJUST_TT32,
      ],
    },
  });
};

SummaryInvoiceDataService.getReportLog = id => {
  return fetch({
    url: `${env.API_MSP}/reports/log/${id}`,
    method: "get",
  });
};

export default SummaryInvoiceDataService;
